export enum MessageType {
  text = 'message',
  image = 'image',
  video = 'video',
}

export interface IMessage {
  type: MessageType;
  content: string;
  header: string;
}

export interface ICustomizations {
  redirectUrl: string | null;
  redirectHeader: string | null;
  redirectButton: string | null;
  redirectConfirm: boolean;
  redirectMessage: string | null;
  hidePrefilledReasons: boolean;
  hideHeaders: boolean;
  messageImageUrl: string | null;
  mobileMessageImageUrl: string | null;
}
